import { render, staticRenderFns } from "./supplierComplianceInspectionWZCG.vue?vue&type=template&id=716f853a&scoped=true"
import script from "./supplierComplianceInspectionWZCG.vue?vue&type=script&lang=js"
export * from "./supplierComplianceInspectionWZCG.vue?vue&type=script&lang=js"
import style0 from "./supplierComplianceInspectionWZCG.vue?vue&type=style&index=0&id=716f853a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f853a",
  null
  
)

export default component.exports